import React from "react";
import { Link } from "react-router-dom";
import { SPA_SERVICES } from "../../data/site";

const SpaCard = ({ service }) => (
  <Link
    to={`/spa-services/${service.slug}`}
    className="group relative block w-full max-w-[320px] overflow-hidden bg-[#ffffff] shadow-xl hover:shadow-[0_20px_40px_-10px_rgba(200,168,120,0.4)] transition-all duration-500"
  >
    <div className="absolute inset-0 p-[1px] pointer-events-none z-10">
      <div
        className="w-full h-full"
        style={{
          background: "linear-gradient(180deg, #F0E3C8 0%, #B79A68 40%, #20322E 100%)",
          WebkitMask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
          padding: "1px",
        }}
      />
    </div>
    <div className="relative h-72 overflow-hidden">
      <img
        src={service.image}
        alt={service.name}
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms] ease-out"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#FBF8F1]/96 via-[#FBF8F1]/45 to-[#ffffff]/15" />
      <div className="absolute bottom-0 left-0 right-0 p-5 text-center">
        <h3 className="font-cinzel text-sm text-[#1f3b5d] uppercase tracking-[0.18em] leading-tight">
          {service.name}
        </h3>
        <div className="flex items-center justify-center gap-2 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="h-px w-6 bg-[#c8a878]" />
          <span className="text-[#1f3b5d] text-[10px] uppercase tracking-[0.3em] font-semibold">Discover</span>
          <span className="h-px w-6 bg-[#c8a878]" />
        </div>
      </div>
    </div>
  </Link>
);

const SpaServicesSection = () => {
  return (
    <section id="spa-services" className="relative bg-gradient-to-b from-[#F6EEDC] via-[#FBF8F1] to-[#ffffff] py-10 border-t border-[#c8a878]/18">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-script text-4xl md:text-5xl gold-gradient-text p-2">Exclusive</p>
          <h2 className="font-cinzel text-2xl md:text-4xl text-[#1f3b5d] tracking-[0.2em] -mt-2">
            SPA SERVICES
          </h2>
          <div className="flex items-center justify-center gap-3 my-5">
            <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#c8a878]" />
            <span className="text-[#1f3b5d] text-[10px] uppercase tracking-[0.4em] font-semibold">Indulge & Renew</span>
            <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#c8a878]" />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5 md:gap-6 justify-items-center">
          {SPA_SERVICES.map((s,index) => (
          <React.Fragment key={s.slug}>
            <SpaCard key={s.slug} service={s} />

            {/* {index === 0 && SPA_SERVICES.length >= 1 && (
              <div
                data-testid="spa-service-video"
                className="bg-cream reveal"
                style={{ transitionDelay: "60ms" }}
              >
                <div className="h-[290px]  overflow-hidden">
                  <video
                    className="w-full h-full object-cover scale-125"
                    src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/testimonials/8bdce0df-5e4c-4aa6-b458-fe1351b40c6d.mp4"
                    autoPlay
                    loop
                    muted
                    controls
                    playsInline
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
          )} */}
          </React.Fragment>

          ))}
        </div>
      </div>
    </section>
  );
};

export default SpaServicesSection;
